import { styleTags, tags as t } from '@lezer/highlight';

export const jsTemplateHighlight = styleTags({
  Text: t.special(t.string),
  TemplateStart: t.special(t.brace),
  TemplateEnd: t.special(t.brace),
});
